import React, { ReactNode, useState, useEffect } from "react";
import styles from "./index.module.scss";
import Upload from "../../shared/assets/icons/upload.svg";
import { Button } from "../../shared/ui/Button";
import { Loader } from "../../shared/ui/Loader";
import { FileInput } from "../../shared/ui/FileInput";
import { sendVerification } from "../../shared/store/payment/api";
import { IOffer } from "../../shared/store/payment/types";
import { OverlayLoader } from "../../shared/ui/OverlayLoader";

interface IVerificationForm {
  icon: string;
  title: string;
  description: ReactNode;
  orderNum: string | null;
  textBtn: string;
  offerData: IOffer;
  isSumFieldVisible?: boolean;
  attachFile: boolean;
  inputSetting?: {
    fileInputPlaceholder: string;
    signatures: string[];
    accept: string;
    warn: string;
  };
  cardNumber: boolean;
  footerContent?: ReactNode;
  bottomContent?: ReactNode;
}

export const VerificationForm: React.FC<IVerificationForm> = ({
  icon,
  title,
  description,
  orderNum,
  textBtn,
  offerData,
  isSumFieldVisible = true,
  attachFile,
  inputSetting,
  cardNumber,
  footerContent,
  bottomContent,
}) => {
  const [sum, setSum] = useState("");
  const [cardNum, setCardNum] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [isFileCorrect, setFileCorrect] = useState<boolean>(true);
  const [isSending, setSendingStatus] = useState<boolean>(false);

  const sendVerif = async () => {
    if (offerData) {
      setSendingStatus(true);
      const resp = await sendVerification(file, offerData.id, sum, cardNum);
      setSendingStatus(false);
    }
  };
  return (
    <div className={styles.wrapper}>
      {isSending && <OverlayLoader />}
      <div className={styles.payment}>
        <div>
          <div className={styles.payment_status_info}>
            <div className={styles.payment_status_header}>
              <img src={icon} alt="" />
              <h3 className="">{title}</h3>
              <p className={styles.payment_status_info_title}>
                Номер заказа {orderNum ? orderNum : <Loader />}
              </p>
              <div>{description}</div>
            </div>
          </div>
          {attachFile && inputSetting && (
            <FileInput
              file={file}
              setFile={setFile}
              isFileCorrect={isFileCorrect}
              setFileCorrect={setFileCorrect}
              placeholder={inputSetting.fileInputPlaceholder}
              accept={inputSetting.accept}
              signatures={inputSetting.signatures}
              warn={inputSetting.warn}
            />
          )}
          <div className={styles.selected_files}></div>
          {isSumFieldVisible && (
            <div className={styles.payment_input}>
              <input
                className={styles.input_text}
                type="text"
                placeholder="Введите сумму перевода"
                min={0}
                value={sum}
                onChange={(e) => {
                  if (/^[0-9]*\.?[0-9]*$/.test(e.target.value))
                    setSum(e.target.value);
                }}
              />
            </div>
          )}
          {cardNumber && (
            <div className={styles.payment_input}>
              <input
                id="input-cardnumber"
                className={styles.input_text}
                type="text"
                placeholder="Введите свой номер карты"
                min={0}
                value={cardNum}
                onChange={(e) => {
                  if (/^[0-9]*\.?[0-9]*$/.test(e.target.value))
                    setCardNum(e.target.value);
                }}
              />
            </div>
          )}

          {footerContent && <div>{footerContent}</div>}
          {attachFile && <Button content={textBtn} onClick={sendVerif} />}
        </div>
      </div>

      {!!offerData.goodLink && (
        <a className={styles.link} href={offerData.goodLink}>
          Вернуться на сайт
        </a>
      )}
      {bottomContent}
    </div>
  );
};
